import React, { useEffect } from 'react';
import ProductDetail from './productDetail';
import Loader from '../../utils/Loader';
import { connect } from 'react-redux';
import {
	getProductDetails,
	setCurrentProductId,
} from '../../redux/buyCourse/buyCourse.actions';
import Sidebar from '../sideBar';

const Purchase = ({ triggerBuyNow, getProductDetails }) => {
	useEffect(() => {
		document.getElementById('chat-circle').style.display = 'none';
		getProductDetails();
		Loader.hide();

		if (localStorage.getItem('TriggerBuyNow') !== 'Yes') {
			Loader.show();
		}
		return () => {
			document.getElementById('chat-circle').style.display = 'block';
		};
	}, [getProductDetails]);

	return (
		<section className="step-container align-stretch container">
			{window.location.pathname === '/purchase' &&
			localStorage.getItem('TriggerBuyNow') !== 'Yes' &&
			window.outerWidth > 768 ? (
				<Sidebar />
			) : null}
			<div className="page-right-section">
				<ProductDetail />
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { triggerBuyNow } = state.rootReducer.buyCourse;
	return {
		triggerBuyNow,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getProductDetails: () => dispatch(getProductDetails()),
		setCurrentProductId: (id) => dispatch(setCurrentProductId(id)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Purchase);
